import { useState } from 'react';
import {
  BaseItem,
  InternalData,
  StickyGroupConfig,
  VirtualizedTableContext,
} from '../VirtualizedTable.types';
import useStickyGroupBands from './stickyGroupBands/useStickyGroupBands';

interface UseStickyGroupHeadersParams<T extends BaseItem> {
  data: InternalData<T>[];
  isEnabled: boolean;
  isCardView: boolean;
}

interface UseStickyGroupHeadersResult<T extends BaseItem> {
  stickyGroup: StickyGroupConfig<T> | undefined;
  stickyGroupOverlayRef: (element: HTMLElement | null) => void;
  virtuosoContext: VirtualizedTableContext;
}

const useStickyGroupHeaders = <T extends BaseItem>({
  data,
  isEnabled,
  isCardView,
}: UseStickyGroupHeadersParams<T>): UseStickyGroupHeadersResult<T> => {
  const [overlay, setOverlay] = useState<HTMLElement | null>(null);
  const isVisible = isEnabled && !isCardView;
  const { bands, bandHeight } = useStickyGroupBands<T>({ data, isEnabled: isVisible, overlay });

  return {
    stickyGroup: isVisible ? { bands, bandHeight } : undefined,
    stickyGroupOverlayRef: setOverlay,
    virtuosoContext: {
      bandedRowIds: new Set(isVisible ? bands.map((band) => band.row.id) : []),
    },
  };
};

export default useStickyGroupHeaders;
